import { VehicleEquipment, VehicleEquipmentStatusEnum } from '../models/vehicle-equipment';

export class InfocarEquipaggiamento {
  codiceGlossario: string;
  descrizioneNorm: string;
  flagQualificante: string;
  stato: string;

  static infocarEquipaggiamentoToVehicleEquipmentDto(infocarEquipaggiamento: InfocarEquipaggiamento): VehicleEquipment {
    let result = new VehicleEquipment();
    result.code = infocarEquipaggiamento.codiceGlossario;
    result.description = infocarEquipaggiamento.descrizioneNorm;
    result.status = result.vehicleEquipmentMapper(infocarEquipaggiamento.stato);
    return result;
  }

}
